import { render, staticRenderFns } from "./UnitOfMeasureSelect.vue?vue&type=template&id=550d76f4"
import script from "./UnitOfMeasureSelect.vue?vue&type=script&lang=ts"
export * from "./UnitOfMeasureSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports